<template>
  <div>
    <HearderTitle :name="title" />
    <div class="auditionFrom">
      <el-form ref="auditionFrom" :rules="rules" :model="auditionFrom" label-width="110px" :inline="true" size="small">
        <p class="title">个人信息</p>
        <el-form-item label="姓名" prop="pername">
          <el-input v-model="auditionFrom.pername"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="auditionFrom.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="auditionFrom.contact"></el-input>
        </el-form-item>
        <el-form-item label="其他联系方式" prop="othercontact">
          <el-input v-model="auditionFrom.othercontact"></el-input>
        </el-form-item>
        <el-form-item label="应聘岗位" prop="gangwei">
          <el-input v-model="auditionFrom.gangwei"></el-input>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker v-model="auditionFrom.birthday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="户籍" prop="province">
          <el-input v-model="auditionFrom.province"></el-input>
        </el-form-item>
        <el-form-item label="户籍所在地" prop="address">
          <el-input v-model="auditionFrom.address"></el-input>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-input v-model="auditionFrom.nation"></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-input v-model="auditionFrom.school"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="edu">
          <el-input v-model="auditionFrom.edu"></el-input>
        </el-form-item>
        <el-form-item label="专业" prop="manjor">
          <el-input v-model="auditionFrom.manjor"></el-input>
        </el-form-item>
        <el-form-item label="面试人" prop="msper">
          <el-input v-model="auditionFrom.msper"></el-input>
        </el-form-item>
        <el-form-item label="婚姻状态" prop="marrage">
          <el-radio-group v-model="auditionFrom.marrage">
            <el-radio label="未婚"></el-radio>
            <el-radio label="已婚"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邀约人" prop="invitePeople">
          <el-input v-model="auditionFrom.invitePeople"></el-input>
        </el-form-item>
        <el-form-item class="pics" label="面试评价" prop="mspj">
          <el-input class="moreinfo" v-model="auditionFrom.mspj"></el-input>
        </el-form-item>
        <el-form-item class="pics" label="自我介绍" prop="info">
          <el-input class="moreinfo" v-model="auditionFrom.info"></el-input>
        </el-form-item>
        <el-form-item label="简历" style="padding: 0 0 0 70px" class="upload2" prop="pics">
          <el-upload class="annaul-ticket-imgs" :on-change="handleEditChange" :class="{ 'hide-upload-btn': hideUploadBtn }" :action="uploadUrl" :limit="5" list-type="picture-card" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="pics_file_list">
            <!-- :file-list="recordpic(personnelFrom.record_pic3)" -->
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item class="pics" label="工作经历" prop="jingyan">
          <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 10 }" class="moreinfo" v-model="auditionFrom.jingyan"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="lightBlueBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <el-button plain size="small" @click="$refs['auditionFrom'].resetFields()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { editAudition, getAuditionInfoById } from '@/api/audition.js'
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'editaudition',
    data() {
      return {
        auditionFrom: {
          pername: '',
          sex: '',
          contact: '',
          othercontact: '',
          gangwei: '',
          birthday: '',
          province: '',
          address: '',
          nation: '',
          organ: '',
          school: '',
          edu: '',
          manjor: '',
          marrage: '',
          mspj: '',
          info: '',
          jingyan: '',
          pics: '',
        },
        dialogImageUrl: '',
        dialogVisible: false,
        hideUploadBtn: false,
        pics_file_list: [],
        rules: {
          pername: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
          sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
          contact: [
            { required: true, message: '联系方式不能为空', trigger: 'blur' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          msper: [{ required: true, message: '面试人不能为空', trigger: 'blur' }],
          gangwei: [{ required: true, message: '面试人不能为空', trigger: 'blur' }],
          mspj: [{ required: true, message: '面试人不能为空', trigger: 'blur' }],
        },
        uploadUrl: '',
        title: '',
        auditionInfo: {},
        id: '',
      }
    },
    async created() {
      // 获取上传url
      this.uploadUrl = process.env.VUE_APP_API_URL + '/Data/do_datapost_kuayu/loaddail?ty=hr'
      this.title = '编辑面试'
      let id = ''
      if (this.$route.params.id) {
        id = this.$route.params.id
        sessionStorage.setItem('auditionId', id)
        // 获取修改数据索引并保存
        sessionStorage.setItem('editDataIndex', this.$route.params.index)
      } else {
        id = JSON.parse(sessionStorage.getItem('auditionId'))
      }
      this.id = id
      this.getAuditionInfoById(id)
    },
    methods: {
      // 提交
      async seve() {
        this.$refs['auditionFrom'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          if (this.id !== '') {
            let data = { id: this.id, ...this.auditionFrom }
            res = await editAudition(data)
            // 缓存修改的数据
            sessionStorage.setItem('editData', JSON.stringify(data))
          } else {
            res = await editAudition(this.auditionFrom)
          }
          if (res.status !== 200) return this.$message.error('提交失败')
          this.$message.success('提交成功')
          return this.$router.go(-1)
        })
      },
      // 根据id查询人员信息
      async getAuditionInfoById(id) {
        let res = await getAuditionInfoById({ id })
        this.auditionFrom = res.data
        this.pics_file_list = this.file_list(this.auditionFrom.pics)
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },

      handleEditChange(file, fileList) {
        this.hideUploadBtn = fileList.length >= 5
      },
      // 上传图片
      handleAvatarSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        console.log(this.auditionFrom.pics)
        let len = this.auditionFrom.pics.length
        if (len === 0) {
          this.auditionFrom.pics += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.auditionFrom.pics += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      handleRemove(file, fileList) {
        let removeUrl = file.url
        let record_pic1 = this.auditionFrom.pics.split(',').filter((v, index) => {
          if (v.indexOf(removeUrl) === -1) return v
        })
        this.auditionFrom.pics = record_pic1.join(',')
        this.hideUploadBtn = fileList.length >= 5
      },
      // 上传限制
      beforeAvatarUpload(file) {
        const isJPG = ['image/jpeg', 'image/png']
        const isLt5M = file.size / 1024 / 1024 < 6
        if (!isJPG.includes(file.type)) {
          this.$message.error('上传头像图片只能是JPG或PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传头像图片大小不能超过 5MB!')
        }
        return isJPG.includes(file.type) && isLt5M
      },
      file_list(val) {
        if (val === '' || !val) return []
        let arr = []
        val.split(',').forEach((v) => {
          arr.push({ url: v })
        })
        return arr
      },
    },
    components: { HearderTitle },
  }
</script>

<style lang="less">
  .auditionFrom {
    margin: 0 auto;
    margin-top: 40px;
    width: 976px;
    .title {
      font-size: 14px;
      color: #666666;
      border-left: 3px solid #1f7ac3;
      height: 14px;
      padding-left: 5px;
      line-height: 14px;
      margin-bottom: 5px;
    }
    .el-upload-list__item-status-label {
      background-color: #1f7ac3;
      width: 36px;
      height: 22px;
    }
    .hide-upload-btn {
      .el-upload--picture-card {
        display: none;
      }
    }
    .el-form-item {
      padding-left: 70px;
      .el-form-item__label {
        font-size: 12px;
      }
      &:nth-of-type(2n) {
        padding-left: 40px;
      }
      &.pics {
        padding-left: 70px;
      }
      &:last-of-type {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        .el-button {
          width: 112px;
          height: 32px;
          padding: 0;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          margin-right: 20px;
        }
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner,
      .el-input__inner {
        width: 300px;
      }
      .el-date-editor .el-input__inner {
        padding-left: 15px;
      }
      .moreinfo {
        width: 100%;
        .el-input__inner,
        .el-textarea__inner {
          width: 760px;
        }
      }
    }
  }
</style>
